// This icon file is generated automatically.
var PPlaySquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M5.91 9.59l3.12-2.45a.18.18 0 000-.28L5.9 4.41a.18.18 0 00-.29.14v4.9c0 .15.18.23.3.14z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-play-square", "theme": "outlined" };
export default PPlaySquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPlaySquareOutlined.js
// module id = 3545
// module chunks = 0